module.exports = __webpack_public_path__ + "img/8D.84c7513d.png";